import {
  CustomEventDetailTrackView,
  CustomEventDetailTrackEvent,
} from "../types";
import {
  CUSTOM_EVENT_TRACK_VIEW,
  CUSTOM_EVENT_TRACK_EVENT,
  CUSTOM_EVENT_CLEAR_VIEW,
} from "./dispatchers";
import { debugLog } from "./debugLog";
import getUtag from "./getUtag";
import {
  trackViewSequentially,
  trackEventSequentially,
  clearView,
} from "./sequenceDecorator";

export const init = (): void => {
  debugLog("Initialise Argonaut Analytics");

  debugLog("Adding event listener to CUSTOM_EVENT_TRACK_VIEW event");
  document.addEventListener(CUSTOM_EVENT_TRACK_VIEW, ((
    event: CustomEvent<CustomEventDetailTrackView>,
  ) => {
    debugLog(
      "Received CUSTOM_EVENT_TRACK_VIEW event.",
      event.detail.viewDataGetters,
    );
    void trackViewSequentially(getUtag, event.detail.viewDataGetters);
  }) as EventListener);

  debugLog("Adding event listener to CUSTOM_EVENT_TRACK_EVENT event");
  document.addEventListener(CUSTOM_EVENT_TRACK_EVENT, ((
    event: CustomEvent<CustomEventDetailTrackEvent>,
  ) => {
    debugLog("Received CUSTOM_EVENT_TRACK_EVENT event.", [
      event.detail.eventDataGetter,
      ...(event.detail.additionalViewDataGetters || []),
    ]);
    void trackEventSequentially(
      getUtag,
      event.detail.eventDataGetter,
      event.detail.additionalViewDataGetters,
    );
  }) as EventListener);

  debugLog("Adding event listener to CUSTOM_EVENT_CLEAR_VIEW event");
  document.addEventListener(CUSTOM_EVENT_CLEAR_VIEW, (() => {
    debugLog("Received CUSTOM_EVENT_CLEAR_VIEW event.");
    clearView();
  }) as EventListener);
};
